//
// Module for common functions for numerical inputs
//
rs.module("pg/numerical-input",

    [],

    function () {
        // Determine if n is a number
        function isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        // Add the contents of provided inputs
        function getSumOfInputs(inputs) {
            // https://stackoverflow.com/questions/1230233/how-to-find-the-sum-of-an-array-of-numbers/43363105#43363105
            return inputs.reduce((accumulator, input) => accumulator + (isNumber(input.normalizedCurrencyVal()) ? parseFloat(input.normalizedCurrencyVal()) : 0), 0);
        }

        // Add the contents of provided inputs, putting the result in resultInput, optionally rounded off to precision
        function _sumInputs(resultInput, precision) {
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments#defining_a_function_that_concatenates_several_strings
            let inputs = Array.prototype.slice.call(arguments, 2);

            let result = getSumOfInputs(inputs);

            if (precision) {
                result = result.toFixed(precision);
            }

            resultInput.val(result);
        }

        // Register the input event of provided inputs to put their sum in resultInput, optionally rounded off to precision
        function registerSumInputs(resultInput, precision) {
            let args = Array.prototype.slice.call(arguments);
            let inputs = args.slice(2);

            inputs.forEach(input => {
                input.on('input', function () {
                    // https://stackoverflow.com/questions/3914557/passing-arguments-forward-to-another-javascript-function/3914600
                    _sumInputs.apply(null, args);
                });
            });
        }

        // Exported public API
        var exports = {
            isNumber,
            getSumOfInputs,
            registerSumInputs
        };

        return exports;
    });